import { render } from "./Postagem.vue?vue&type=template&id=dd87319c&scoped=true"
import script from "./Postagem.vue?vue&type=script&lang=js"
export * from "./Postagem.vue?vue&type=script&lang=js"

import "./Postagem.vue?vue&type=style&index=0&id=dd87319c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd87319c"]])

export default __exports__